import { getLocale } from "../i18n";
export const CURRENCY = "₭"; // ₭ — Lao kip sign (U+20AD)
const intlLocale = () => (getLocale() === "lo" ? "lo-LA" : "en-US");
export const fmt = (n) => n.toLocaleString(intlLocale());
export const fmtKip = (n) => `${fmt(n)} ${CURRENCY}`;
export const fmtDate = (iso) => new Date(iso).toLocaleDateString(intlLocale(), { year: "numeric", month: "2-digit", day: "2-digit" });
export const fmtTime = (iso) => new Date(iso).toLocaleTimeString(intlLocale(), { hour: "2-digit", minute: "2-digit", hour12: false });
export const initials = (name) => name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
// Compact a UUID for human display: "f0c772ed-962b-4aa3-af6a-53a7de993d3a" -> "#993D3A".
// Short ids (no dashes, or mockup-style "H-21") pass through unchanged so we don't mangle
// fixtures or future human-friendly IDs.
export const shortId = (id) => {
    const compact = id.replace(/-/g, "");
    if (compact.length >= 16)
        return `#${compact.slice(-6).toUpperCase()}`;
    return id;
};
//# sourceMappingURL=fmt.js.map